import { EntryType } from 'openapi';

import { DocumentsUpload } from 'pages/DocumentsUpload/DocumentsUpload';

import { getRevenueColumns } from 'utils/helpers/revenueHelper';
import { ExpensesProps } from 'utils/interfaces/ActionsEnabled';
import { AppRoutesEnum } from 'utils/routes';

export const Revenue = ({ isOnAllCompanies, filterType }: ExpensesProps) => {
  return (
    <DocumentsUpload
      filterType={filterType}
      isOnAllCompanies={isOnAllCompanies}
      stateRoute={
        isOnAllCompanies ? AppRoutesEnum.REVENUE : AppRoutesEnum.COMPANY_REVENUE
      }
      getColumns={(translate) =>
        getRevenueColumns(isOnAllCompanies ?? false, translate)
      }
      entryType={EntryType.REVENUE}
    />
  );
};
